import { render, staticRenderFns } from "./asignar-supervision.vue?vue&type=template&id=6e39848a"
import script from "./asignar-supervision.vue?vue&type=script&lang=js"
export * from "./asignar-supervision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports